import React from 'react';
import { omit } from 'lodash';
import { useSaveRoot } from '../saveRoot';
import * as actions from '../actions';
import valueFilters from '../valueFilters';
import * as employeeActions from '../employeeActions';
import * as statsActions from '../statsActions';import componentServices from '../componentServices';
import employeeFactory, { IEmployee } from '../models/employeeModel';
import { CurrencyInput } from './sharedComponents';
import validator from '../validator';
import { getModel, ModelCollection } from '../store';

export default function SalesGoalEntryModal(props) {
	const { employeeKey, fiscalYear } = props;
	const [saveRoot] = useSaveRoot<IEmployee>({
		autoSave:  false,
		globalSave: false,
		warnOnLeave: false,
		stateId: 'SalesGoalEntryModal',
		modelFactory: employeeFactory,
		resolveMutableModel (current) {
			const storeModel = getModel({ store: componentServices.store, collection: ModelCollection.employees, key: employeeKey });
			let employee = current;
			let rebase = false;

			if (!current || storeModel.key !== current.key) {
				employee = employeeFactory(storeModel.toDocument());
			}
			else if (storeModel.key === current.key && storeModel.itemVersion !== current.itemVersion) {
				employee = employeeFactory(storeModel.toDocument());
				rebase = true;
			}

			return [employee, rebase];
		},
		save: (doc, patch) => employeeActions.saveEmployee({ employee: doc, patch: patch }),
		savedCallback: () => {
			statsActions.updateEmployeeGoal({ year: fiscalYear, employeeKey });
			actions.popModal();
		},
		validate(model) {
			const messages = validator.test(model, omit(employeeFactory.rules(), ['user'])) || [];

			model.user.test('userName', messages);

			return messages;
		}
	});

	function updateProfileValue (name, autoSave, e) {
		const newVal = autoSave ? valueFilters.clean(e.target.value) : e.target.value;

		saveRoot.update((model) => {
			model.setProfileValue(name, newVal);
		}, { autoSave: false });
	}

	const employee = saveRoot.model;
	const profileItemName = `salesGoalFY${fiscalYear}`;

	if (!employee || !saveRoot) { return null; }

	return (<div className="window">
		<header><button className="cancel" onClick={ actions.popModal }><span>Cancel</span> </button><span>Fiscal Year Sales Goal</span>{ saveRoot.getSaveButton()}</header>
		<div className="views">
			<div className="content in scrollable">
				<section>
					<div className="inner compact">
						<table className="centered" cellPadding="0" cellSpacing="0">
							<tbody>
								<tr>
									<td />
									<td><strong>{ `Fiscal Year ${fiscalYear} Sales Goal`}</strong></td>
									<td><CurrencyInput type="text" placeholder="" value={ employee.getProfileValue(profileItemName, '0')} onChange={ updateProfileValue.bind(null, profileItemName, false) } onBlur={ updateProfileValue.bind(null, profileItemName, true) } /></td>
									<td />
								</tr>
							</tbody>
						</table>
					</div>
				</section>
			</div>
		</div>
	</div>);
}